import {
  UserGroupIcon,
  ClockIcon,
  EyeDropperIcon,
  MagnifyingGlassIcon,
  AcademicCapIcon,
  FaceSmileIcon,
  PhoneIcon,
  PrinterIcon,
  EnvelopeIcon,
  SparklesIcon,
  CloudIcon,
  ArrowDownIcon,
  CogIcon,
  PaintBrushIcon,
  CameraIcon,
  CheckCircleIcon,
  DocumentIcon
} from "@heroicons/react/24/solid";

import benefitOneImg from "../img/benefit-one.png";

// Blend pictures
import blend1 from "../img/manufacture/blend/blend1.jpg";
import blend2 from "../img/manufacture/blend/blend2.jpg";
import blend3 from "../img/manufacture/blend/blend3.jpg";

// Capsule pictures
import capsuling1 from "../img/manufacture/capsule/capsuling1.jpg";
import capsuling2 from "../img/manufacture/capsule/capsuling2.jpg";
import capsuling3 from "../img/manufacture/capsule/capsuling3.jpg";

//Tablet pictures
import tabletting1 from "../img/manufacture/tablet/tabletting1.jpg";
import tabletting2 from "../img/manufacture/tablet/tabletting2.jpg";
import tabletting3 from "../img/manufacture/tablet/tabletting3.jpg";

//Blister pictures
import blister2 from "../img/conditionning/blister/blister2.jpg";
import blister3 from "../img/conditionning/blister/blister3.jpg";

//Pot pictures
import pot1 from "../img/conditionning/pot/pot1.jpg";
import pot2 from "../img/conditionning/pot/pot2.jpg";

//Powder pictures
import powder1 from "../img/conditionning/powder/powder1.jpg";
import powder2 from "../img/conditionning/powder/powder2.jpg";

//Contact
import plan from "../img/plan.jpg";

//NotFound pictures
import notFound1 from "../img/notFound/notFound1.png";
import notFound2 from "../img/notFound/notFound2.png";
import notFound3 from "../img/notFound/notFound3.png";

const dataFR = {
  navigation: [
    {
      href: "/",
      label: "Accueil",
    },
    {
      href: "/manufacture",
      label: "Fabrication",
    },
    {
      href: "/conditionning",
      label: "Conditionnement",
    },
    {
      href: "/quality",
      label: "Qualité",
    },
    {
      href: "/contact",
      label: "Contact",
    },
  ],
  home: {
    preTitle: "Les Avantages de Pharma Manufacturing",
    title: "Expertise & Qualité",
    desc: (
      <>
        Fabrication à façon de compléments alimentaires selon les normes{" "}
        <span className="text-green-500">GMP</span> et la certification{" "}
        <span className="text-green-500">FSSC22000.</span> <br />
        Expertise pharmaceutique depuis <span className="font-bold">1988</span>.
        <br />
        Qualité garantie par des professionnels dont{" "}
        <span className="font-bold">
          <span className="text-green-500">3</span> pharmaciens
        </span>{" "}
        et par des <span className="font-bold">équipements de pointe.</span>
      </>
    ),
  },
  hero: {
    eyebrow: "Expertise pharmaceutique",
    sinceLabel: "Depuis",
    title: "Pharma Manufacturing",
    desc: (
      <>
        Depuis plus de 30 ans, notre expertise pharmaceutique au service de
        votre bien-être. <br />
        Des équipements de pointe pour une production conforme aux normes les
        plus strictes.
      </>
    ),
    subDesc: (
      <>
        Un parc de <span className="text-green-500">plus de 50</span> machines
        pour répondre à tous vos projets.
      </>
    ),
    calloutLabel: "Production",
    calloutText: "Plus de 50 machines pour accompagner tous vos projets.",
  },
  benefitOne: {
    title: "Expertise",
    desc: "Pharma Manufacturing, c'est l'assurance d'un savoir-faire unique. Forte d'une expérience de plusieurs décennies, notre équipe pluridisciplinaire composée de pharmaciens et de diététiciens met à votre disposition une expertise pointue en formulation et production de compléments alimentaires. De la conception à la réalisation, nous vous accompagnons dans tous vos projets.",
    image: benefitOneImg,
    bullet: true,
    bullets: [
      {
        title: "Équipe pluridisciplinaire",
        desc: "Composée d'un Pharmacien d'industrie, de pharmaciens et d'un diététicien",
        icon: <UserGroupIcon />,
      },
      {
        title: "Expérience reconnue",
        desc: "Depuis 1988",
        icon: <ClockIcon />,
      },
      {
        title: "Maîtrise des normes",
        desc: "FSSC2200, BIO  ",
        icon: <AcademicCapIcon />,
      },
    ],
  },
    PrivateLabel: {
    preTitle: "Votre marque, notre expertise",
    title: "Private label",
  },
  manufacture: {
    preTitle: "L'art de la fabrication",
    title: "Fabrication",
  },
    notification: {
    preTitle: "Accompagnement réglementaire complet par une équipe de pharmaciens et spécialistes du complément alimentaire.",
    title: "Demande de notification pour compléments alimentaires",
  },
  blend: {
    title: "Mélange",
    desc: "Disposant de plusieurs mélangeurs de toutes tailles, de type planétaire ou tumbler, Pharma manufacturing peut garantir l’homogénéité de vos mélanges pour les petites et grandes quantités.",
    desc2: "",
    // <>
    //   <br></br>Capacité journalière:{" "}
    //   <span className="text-green-500 "> 3 </span> tonnes
    // </>

    desc3: "",
    images: [blend1, blend2, blend3],
    bullet: false,
    bullets: [
      {
        title: "Produits purs",
        desc: "Fabrication soignée et sous contrôle",
        icon: <EyeDropperIcon />,
      },
      {
        title: "Produits purs",
        desc: "Fabrication soignée et sous contrôle",
        icon: <EyeDropperIcon />,
      },
      {
        title: "Satisfaction clients",
        desc: "Efficacité et confiance prouvée",
        icon: <FaceSmileIcon />,
      },
    ],
  },
  capsule: {
    title: "Gélules",
    desc: "Possédant 5 géluleuses de différentes capacités aux formats 00, 0, 1, Pharma Manufacturing peut assurer sans aucun problème la fabrication de tout volume à partir de 50.000 capsules.",
    desc2: "",
    // <>
    //   <br></br>Capacité journalière maximale:
    //   <span className="text-green-500"> 2.250.000</span> capsules
    // </>

    images: [capsuling1, capsuling2, capsuling3],
    bullet: true,
    bullets: [
      {
        title: "Polissage",
        desc: "",
        icon: <SparklesIcon />,
      },
      {
        title: "Dépoussiérage",
        desc: "",
        icon: <CloudIcon />,
      },
    ],
  },
  tablet: {
    title: "Comprimés",
    desc: "Doté de 2 comprimeuses polyvalentes avec pré-compression, Pharma Manufacturing peut non seulement fabriquer des comprimés de toutes tailles jusqu’à 23 mm et de toutes formes souhaitées, rondes et pilules mais également oblongues pouvant contenir jusqu'à un gramme et demi de matière active.",
    desc2: "",
    // <>
    //   <br></br>Capacité journalière maximale:
    //   <span className="text-green-500"> 730.000</span> comprimés
    // </>

    images: [tabletting1, tabletting2, tabletting3],
    bullet: true,
    bullets: [
      {
        title: "Compression directe",
        desc: "La poudre est directement comprimée après mélange",
        icon: <ArrowDownIcon />,
      },
      {
        title: "Compression après granulation",
        desc: "Durant le mélange, nous granulons certains ingrédients pour une meilleure compression",
        icon: <CogIcon />,
      },
      {
        title: "Pelliculage",
        desc: "A la suite de la compression, nous pouvons pélliculer les comprimés",
        icon: <PaintBrushIcon />,
      },
    ],
  },
  conditionning: {
    preTitle: "Toujours une option pour vos produits",
    title: "Conditionnement",
  },
  blister: {
    title: "Blistérisation",
    desc: "Doté de 5 blistériseuses et d’une encartonneuse, Pharma Manufacturing possède une capacité journalière importante qui permet de vous fournir dans les meilleurs délais. ",
    desc2: "",
    // <>
    //   <br></br>Capacité journalière maximale:{" "}
    //   <span className="text-green-500"> 264.000</span> blisters et{" "}
    //   <span className="text-green-500"> 66.000</span> boîtes
    // </>

    desc3: "",
    images: [ blister2, blister3],
    bullet: true,
    bullets: [
      {
        title: "Caméra",
        desc: "Une caméra scrute les défauts et éjectent les blisters non conformes",
        icon: <CameraIcon />,
      },
      {
        title: "Contrôle automatique de l'encartonneuse",
        desc: "Un contrôle automatique est réalisé par la machine afin de vérifier que la bonne quantité de blisters soit dans l'étui",
        icon: <CheckCircleIcon />,
      },
      {
        title: "Présence de notice",
        desc: "Le contrôle automatique vérifie également si la notice est bien présente dans l'étui",
        icon: <DocumentIcon />,
      },
    ],
  },
  powder: {
    title: "Poudres",
    desc: "Conditionnement de poudres diététiques en pots ou en seaux de petit ou grand volume.",
    desc2: "",
    // <>
    //   <br></br>Capacité journalière : à définir selon le type de
    //   conditionnement.
    // </>

    desc3: "",
    images: [powder1, powder2],
    bullet: false,
    bullets: [
      {
        title: "Contrôle rigoureux",
        desc: "Respect des différentes certifications suivies",
        icon: <MagnifyingGlassIcon />,
      },
      {
        title: "Produits purs",
        desc: "Fabrication soignée et sous contrôle",
        icon: <EyeDropperIcon />,
      },
      {
        title: "Satisfaction clients",
        desc: "Efficacité et confiance prouvée",
        icon: <FaceSmileIcon />,
      },
    ],
  },
  pot: {
    title: "Mise en flacon",
    desc: "Disposant d'une compteuse optique et d'une étiqueteuse, Pharma manufacturing peut ainsi mettre en flacon de toute taille des comprimés et des gélules et y apposer une étiquette.",
    desc2: "",
    desc3: "",
    images: [pot1, pot2],
    bullet: false,
    bullets: [
      {
        title: "Contrôle rigoureux",
        desc: "Respect des différentes certifications suivies",
        icon: <MagnifyingGlassIcon />,
      },
      {
        title: "Produits purs",
        desc: "Fabrication soignée et sous contrôle",
        icon: <EyeDropperIcon />,
      },
      {
        title: "Satisfaction clients",
        desc: "Efficacité et confiance prouvée",
        icon: <FaceSmileIcon />,
      },
    ],
  },
  team: {
    title: "Un accompagnement concret, par une équipe pharmaceutique",
    desc: "Mettre un complément alimentaire sur le marché ne se résume pas à une bonne formule ou un beau packaging. Avant toute commercialisation, une étape incontournable s’impose : la notification auprès des autorités compétentes.",
    desc2: "En pratique, c’est souvent là que les projets ralentissent. Dossier incomplet, ingrédient borderline, allégation mal formulée… les retours peuvent être nombreux si la préparation n’est pas rigoureuse.",
    desc3: "Chez Pharma Manufacturing, nous accompagnons nos clients dans cette démarche au quotidien, avec une approche simple : anticiper les problèmes avant qu’ils ne bloquent votre mise sur le marché.",
    images: [pot1, pot2],
    bullet: false,
    bullets: [
      {
        title: "Contrôle rigoureux",
        desc: "Respect des différentes certifications suivies",
        icon: <MagnifyingGlassIcon />,
      },
      {
        title: "Produits purs",
        desc: "Fabrication soignée et sous contrôle",
        icon: <EyeDropperIcon />,
      },
      {
        title: "Satisfaction clients",
        desc: "Efficacité et confiance prouvée",
        icon: <FaceSmileIcon />,
      },
    ],
  },
  quality: {
    title: "Qualité",
    desc: "Contrôle de qualité permanent par notre pharmacien d’industrie, nos deux pharmaciens et leur équipe :",
    controlList: [
      "Contrôle et pesée des matières premières livrées  ",
      "Contrôle du mélange et vérification du poids total obtenu",
      "Pesées individuelles de comprimés et gélules en cours de production",
      "Test de dureté, de désagrégation et de friabilité des comprimés",
      "Test d’étanchéité des blisters",
      "Validation de la production par le pharmacien responsable",
      "Elaboration des dossiers fabrications respectant les GMP (traçabilité des opérations de fabrication et de conditionnement)",
      "Respect des bonnes pratiques de fabrication actuellement en vigueur (GMP) ainsi que les normes HACCP et FSSC22000",
      "Procédures de flux des matières dans la zone de fabrication et respect du FIFO (first in, first out) à la pesée",
      "Travail décrit par des procédures standards (SOP)",
      "Chambre froide pour la conservation entre autres des probiotiques avant et directement après la production afin de garantir la qualité des produits",
    ],
  },

  contact: {
    title: "Contact",
    desc: (
      <>
        <span className="text-green-500 font-bold uppercase">
          Pharma Manufacturing
        </span>
        <br></br>
        Parc Scientifique Créalys <br></br>
        Rue Guillaume Fouquet, 16<br></br>
        5032 ISNES
      </>
    ),
    desc2: "",
    desc3: "",
    image: plan,
    imageFrame: false,
    bullets: [
      {
        title: "Téléphone",
        desc: "+ 32 (0) 81/73.55.81",
        icon: <PhoneIcon />,
      },
      {
        title: "Fax",
        desc: "+ 32 (0) 81/73.55.61",
        icon: <PrinterIcon />,
      },
      {
        title: "E-Mail",
        desc: (
          <>
            <a href="mailto:pharma.manufacturing@gmail.com">
              <span className="text-green-500">pharma.manufacturing@gmail.com</span>
            </a>
          </>
        ),
        icon: <EnvelopeIcon />,
      },
    ],
  },
  notFound: {
    title: "Il semble que vous ayez trouvé la porte du grand rien",
    desc: "Le contenu que vous recherchez n'existe pas. Soit il a été supprimé, soit vous avez mal saisi le lien.",
    desc2:
      "Nous vous prions de bien vouloir nous en excuser. Veuillez consulter notre page d'accueil pour vous rendre là où vous voulez aller.",
    desc3: "Retourner à la page d'accueil",
    images: [notFound1, notFound2, notFound3],
    bullet: false,
    bullets: [
      {
        title: "",
        desc: "",
        icon: "",
      },
      {
        title: "",
        desc: "",
        icon: "",
      },
      {
        title: "",
        desc: "",
        icon: "",
      },
    ],
  },
};

export { dataFR };
